import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const MostReturnedCardSkeleton = () => (
  <Styles.Container>
    <Styles.ProductContainer>
      <Styles.ProductRow>
        <Skeleton variant="text" width={20} height={20} />
        <Skeleton variant="rounded" width={56} height={56} />
        <Styles.ProductInfo>
          <Skeleton variant="text" width={180} height={20} />
          <Skeleton variant="text" width={100} height={16} />
          <Skeleton variant="text" width={80} height={16} />
        </Styles.ProductInfo>
      </Styles.ProductRow>
      <Styles.StatsContainer>
        <Styles.Stat>
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="text" width={80} height={16} />
        </Styles.Stat>
        <Styles.Stat>
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="text" width={80} height={16} />
        </Styles.Stat>
        <Styles.Stat>
          <Skeleton variant="text" width={60} height={24} />
          <Skeleton variant="text" width={80} height={16} />
        </Styles.Stat>
      </Styles.StatsContainer>
    </Styles.ProductContainer>
  </Styles.Container>
)

export default MostReturnedCardSkeleton
